module.exports = __webpack_public_path__ + "img/right_bg2.ed07873.png";